class FaqTabsElement extends HTMLElement {
  constructor() {
    super();
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.currentSection = this;
    this.containers = this.querySelectorAll('.container');
    this.navItems = this.querySelectorAll('.nav-items div');
    this.slider = this.querySelector('.js-faq-tabs-slider');
    this.buttons = this.querySelectorAll('button[id^="toggle-btn-"]');
    this.swiperInstance = null;

    this.hideAllContainers();
    this.setInitialActiveState();
    this.addEventListeners();
    this.initSwiper();
    window.addEventListener(
      'resize',
      debounce(this.handleResize),
      ON_CHANGE_DEBOUNCE_TIMER
    );
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener('resize', this.handleResize);
  }

  initSwiper() {
    if (window.innerWidth < 1023 && !this.swiperInstance) {
      this.swiperInstance = new Swiper(this.slider, {
        spaceBetween: 32,
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        watchOverflow: true,
      });
    }
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  handleResize() {
    if (window.innerWidth < 1023) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  hideAllContainers() {
    this.containers.forEach((container) => {
      container.classList.remove('active');
    });
  }

  toggleContainer(index) {
    this.hideAllContainers();
    const targetContainer = this.containers[index];
    targetContainer.classList.add('active');
    this.setNavItemActiveState(index);
  }

  setInitialActiveState() {
    if (this.containers.length > 0 && this.navItems.length > 0) {
      this.containers[0].classList.add('active');
      this.navItems[0].classList.add('active');
    }
  }

  addEventListeners() {
    this.navItems.forEach((navItem, index) => {
      navItem.addEventListener('click', () => this.toggleContainer(index));
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.toggleAccordion(event));
    });
  }

  setNavItemActiveState(index) {
    this.navItems.forEach((navItem, idx) => {
      navItem.classList.toggle('active', idx === index);
    });
  }

  toggleAccordion(event) {
    const targetButton = event.target.closest('button');
    const content = targetButton.nextElementSibling;
    const icon = targetButton.querySelector('span[id^="icon-"]');

    if (content.style.maxHeight && content.style.maxHeight !== '0px') {
      content.style.maxHeight = '0';
      icon.classList.remove('rotate-up');
      icon.classList.add('rotate-down');
    } else {
      this.closeAllAccordions();
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.classList.remove('rotate-down');
      icon.classList.add('rotate-up');
    }
  }

  closeAllAccordions() {
    const allContents = this.querySelectorAll('.max-h-0');
    allContents.forEach((content) => (content.style.maxHeight = '0'));

    const allIcons = this.querySelectorAll('span[id^="icon-"]');
    allIcons.forEach((icon) => {
      icon.classList.remove('rotate-up');
      icon.classList.add('rotate-down');
    });
  }
}

customElements.define('faq-tabs', FaqTabsElement);
